export default __webpack_public_path__ + "static/media/chef_b.0e410daa.png";